import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5 px-6 text-center bg-background">
      <span className="text-5xl">🚫</span>
      <h1 className="text-xl font-bold text-gray-800">Access Denied</h1>
      <p className="text-sm text-gray-500 max-w-xs">
        This app is for private use only. Only authorised accounts can sign in.
      </p>
      <button
        className="btn-primary"
        onClick={() => navigate('/login')}
      >
        Back to Login
      </button>
    </div>
  );
}
